import React, { Fragment } from 'react';
import Card from './Card';
import Header from './Header';

const Establishments = () => (
    <Fragment>
        <Header />
        <div class="container-fluid mt--6">
            <div class="row">
                <div class="col">
                    <Card />
                </div>
            </div>
        </div>
    </Fragment>
);

export default Establishments;


// WEBPACK FOOTER //
// ./src/components/Pages/Establishments/index.js